var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.list),function(item,i){return _c('v-col',{key:i,staticClass:"pa-2",attrs:{"cols":"12","sm":"6"}},[_c('div',{staticClass:"card card-custom",style:(`background-image: url(${item.src}`)})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }